import { ThumbnailTypes } from 'src/components/thumbnail/types';

enum CONSUMPTION_PAGE_ROUTES {
  MOVIE = 'movies/details'
}

export const getRecoThumbnailType = (pathname: string) => {
  switch (true) {
    case pathname.includes(CONSUMPTION_PAGE_ROUTES.MOVIE): {
      return ThumbnailTypes.vertical;
    }
    default:
      return ThumbnailTypes.upnext;
  }
};
